import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as debounce from 'lodash.debounce';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import {
    query,
    setSearchQuery,
    handleKeyDown,
    handleClickSearch, 
    hideResults,
} from '../Actions/QuickSearch.action';
import usePrevious from '@react-hook/previous';

// debouncing function to 200ms so we don't send query request on every key stroke
const debouncedQuery = debounce((dispatch, text) => dispatch(query(text)), 200);


const QuickSearch = () => {
    const {
        query,
        result,
        showResult,
        selectedItem,
    } = useSelector((state) => state.quickSearch);
    const [lastClickedNode, setLastClickedNode] = useState(null);
    const searchUrl =
        window.__litium.quickSearchUrl +
        (query.length > 0 ? `?q=${query}` : '');
    const searchContainer = useRef(null);
    const searchInput = useRef(null);
    const dispatch = useDispatch();
    const previousSelectedItem = usePrevious(selectedItem);

    const clickHandler = useCallback((event) => {
        setLastClickedNode(event.target);
    }, []);
    // useEffect(() => {
    //     // listen for click event to hide the search when clicking outside
    //     // window.addEventListener('mousedown', clickHandler);
    //     // return () => window.removeEventListener('mousedown', clickHandler);
    // }, [clickHandler]);

    useEffect(() => {
        
    }, []);
    useEffect(() => {
        // set query value if it is avaialble in the Url
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('q')) {
            const query = urlParams.get('q');
            dispatch(setSearchQuery(query));
        }
    }, [dispatch]);

    useEffect(() => {
        if (selectedItem !== previousSelectedItem) {
            const el = document.querySelector(
                '.quick-search-result__item--selected'
            );
            el &&
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest',
                });
        }
    }, [selectedItem, previousSelectedItem]);

    function useOutsideAlerter(ref) {
        const dispatch = useDispatch();
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    // alert("You clicked outside of me!");
                    dispatch(hideResults());
                    // dispatch(toggleShowFullForm()
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    
    useOutsideAlerter(searchContainer);
    
    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            dispatch(handleClickSearch({ searchUrl }));
        }}>
            <div className="quick-search" role="search" ref={searchContainer}>
                <div
                    className={`quick-search__form quick-search__form--force-show`}
                    role="search"
                >
                    <input
                        className="quick-search__input"
                        type="search"
                        placeholder={translate('general.search')}
                        autoComplete="off"
                        value={decodeURIComponent(query)}
                        onChange={(event) => {
                            const text = encodeURIComponent(event.target.value);
                            dispatch(setSearchQuery(text));
                            debouncedQuery(dispatch, text);
                        }}
                        onKeyDown={(event) =>
                            dispatch(handleKeyDown(event, { searchUrl }))
                        }
                        ref={searchInput}
    
                    />
                    <button
                        className="quick-search__submit-button"
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            dispatch(handleClickSearch({ searchUrl }));
                        }}
                    >
                        <i className="quick-search__submit-icon"></i>
                        <span className="quick-search__submit-title">
                            {translate('general.search')}
                        </span>
                    </button>
                </div>
                {showResult && (
                    <QuickSearchResult
                        result={result}
                        selectedItem={selectedItem}
                        searchUrl={searchUrl}
                    />
                )}
            </div>
        </form>
    );
};

export default QuickSearch;
